import { render } from "./Specifications.vue?vue&type=template&id=90a53f6a&scoped=true"
import script from "./Specifications.vue?vue&type=script&lang=js"
export * from "./Specifications.vue?vue&type=script&lang=js"

import "./Specifications.vue?vue&type=style&index=0&id=90a53f6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a53f6a"]])

export default __exports__